if (!customElements.get('price-reveal-toggle')) {
  customElements.define(
    'price-reveal-toggle',
    class PriceRevealToggle extends HTMLElement {
      connectedCallback() {
        this.container = this.closest('.product__info-container');
        this.toggleButton = this.querySelector('.sam-price-reveal__toggle');
        this.toggleLabel = this.querySelector('.sam-price-reveal__toggle-label');

        if (!this.container || !this.toggleButton) return;

        this.toggleButton.addEventListener('click', this.handleToggleClick.bind(this));

        this.unsubscribeVariantChange = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );
      }

      disconnectedCallback() {
        this.unsubscribeVariantChange?.();
      }

      handleToggleClick() {
        const isOpen = this.container.classList.toggle('sam-price-reveal--open');
        this.toggleButton.setAttribute('aria-expanded', isOpen);
      }

      handleVariantChange(event) {
        const sectionId = this.container.id.replace('ProductInfo-', '');
        if (event.data.sectionId !== sectionId) return;
        if (!event.data.variant) return;

        // Deliberately does NOT touch 'sam-price-reveal--open' — the variant
        // picker stays visible after a pick so the shopper can immediately
        // choose a different variant instead of having to reopen the toggle.
        this.container.classList.add('sam-price-reveal--selected');

        if (this.toggleLabel && event.data.variant.title) {
          this.toggleLabel.textContent = event.data.variant.title;
        }
      }
    }
  );
}
